<template>
  <hr
    :style="{
      marginTop: '15px',
      marginBottom: '15px',
      width: '100%',
      border: '0',
      borderTop: '1px solid'
    }"
  />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Divider"
};
</script>
